import { render, staticRenderFns } from "./ThreeDModelWidget.vue?vue&type=template&id=bdcd6a48&scoped=true"
import script from "./ThreeDModelWidget.vue?vue&type=script&lang=js"
export * from "./ThreeDModelWidget.vue?vue&type=script&lang=js"
import style0 from "./ThreeDModelWidget.vue?vue&type=style&index=0&id=bdcd6a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcd6a48",
  null
  
)

export default component.exports